<section id="about">
  <div class="container">
      <div class="row">
          <div class="col-12">
              <h1>Investing for Catholics Mobile App Privacy Policy</h1>
          </div>
      </div>
  </div>
</section>

  <section class="section" id="app-pp">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
<i class="text-end">Last updated: February 3, 2026</i><br/><br/>
Investing for Catholics (IFC) a division of IFA values your privacy. This privacy policy explains how we collect, use, disclose, and protect your personal information when you use the IFC App.
By using the IFC App, you agree to the collection and use of your information in accordance with this privacy policy. If you do not agree with this privacy policy, please do not use the IFC App.
<br/><br/>
1. Information We Collect
We collect the following types of information from users of the IFC App:
<ul>
<li>Device ID: We collect your device ID for SEC compliance purposes if you agree to the IFC Terms and Disclosures before using the IFC App. We may also collect your device ID on an opt-in basis for marketing purposes, such as push notifications.</li>
<li>Approximate location, usage data, and crash logs: We collect this information for analytics purposes to improve the IFC App's functionality and user experience. This data is not linked to you and may be shared with third-party, analytics services.</li>
<li>(Optional information) Name, phone number, and email: We use this information for communication and marketing purposes. We may ask for this information if a user seeks financial advice through the App.</li>
</ul><br/>
2. How We Use Your Information
We use the information we collect from you to:
<ul>
<li>Provide and maintain the App's functionality.</li>
<li>Improve the App's performance and user experience.</li>
<li>Communicate with you about our products and services.</li>
<li>Comply with legal requirements, such as SEC compliance.</li>
</ul><br/>
3. How We Share Your Information
We may share your personal information for the following purposes:
<ul>
<li>For our everyday business purposes, such as processing your transactions, maintaining your account(s), or responding to court orders and legal investigations.</li>
<li>For our marketing purposes, to offer our products and services to you.</li>
</ul>

We do NOT share your information for any of the follow
<ul>
<li>Joint marketing with other financial companies.</li>
<li>Non-affiliates to market to you.in:</li>
</ul><br/>
4. Security
To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings.
<br/><br/>
5. Changes to This Privacy Policy
We may update this privacy policy from time to time. We will notify you of any changes by posting the updated policy on the IFC App. You are advised to review this privacy policy periodically for any changes.
<br/><br/>
6. Your Rights to Limit Sharing
Federal law gives you the right to limit sharing in specific scenarios, such as affiliates from using your information to market to you, or sharing your information with non-affiliates for marketing purposes. State laws and individual companies may provide additional rights to limit sharing.
Please note that not all sharing can be limited, as some sharing is necessary for our everyday business purposes, such as processing transactions, maintaining your account(s), or responding to court orders and legal investigations.
<br/><br/>
7. Data Retention and Deletion Policy
We retain your personal information for as long as it is necessary to fulfill the purposes outlined in this privacy policy, comply with legal obligations, resolve disputes, and enforce our agreements. The retention period may vary depending on the type of data and the specific purpose for which it was collected.
When your personal information is no longer required for these purposes, we will securely delete or anonymize the data in accordance with our data retention and deletion policy. In some cases, we may retain aggregated, anonymized, or statistical information that cannot be associated with an individual for analytical or research purposes.
If you would like to request the deletion of your personal information, please contact us using the information provided in the "Contact Us" section. We will evaluate your request and delete the data, subject to any legal obligations or legitimate interests that may require us to retain the information.
Please note that the deletion of your personal information may result in the loss of certain features or services provided by the IFC App.
<br/><br/>
 8. Contact Us
If you have any questions or concerns about this privacy policy or our privacy practices, please contact us at:
<br/><br/>
Investing for Catholics, a division of Index Fund Advisors, Inc.<br/>
19200 Von Karman Ave. Suite 150<br/>
Irvine, CA 92612<br/>
Phone: <a href="tel:8886433133">888-643-3133</a><br/>
Email: <a href="mailto:info@ifa.com">info&#64;ifa.com</a><br/>
Website: <a href="/">investingforcatholics.com </a>


        </div>
      </div>
    </div>
  </section>
